module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-hollandsnieuwe-bottom-01.1@2x.9e9a4d31.jpg";